import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import './StartupSection.css';
import developerImage from '../assets/Images/developer.png';

const StartupSection = () => {
  return (
    <div className="startup-section">
      <Container maxWidth="lg">
        <div className="startup-content">
          <motion.div 
            className="startup-left"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <Typography variant="h1" className="startup-title">
              FUELING STARTUPS
              <br />
              TO ENTERPRISES
              <span className="dot">.</span>
            </Typography>
            <Typography variant="body1" className="startup-description">
              Whether embarking on app launch, amplifying digital presence, or pioneering
              software innovation, our tailored app development services drive impactful
              outcomes.
            </Typography>
            {/* <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3, ease: 'easeOut' }}
            > */}
              <Button 
                variant="contained" 
                className="talk-button"
                href="/contact"
                sx={{
                  background: 'linear-gradient(90deg, #3F72AF 60%, #112D4E 100%)',
                  color: '#F9F7F7',
                  fontWeight: 700,
                  fontSize: 18,
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  boxShadow: '0 4px 24px rgba(63,114,175,0.10)',
                  textTransform: 'none',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #112D4E 60%, #3F72AF 100%)',
                  },
                }}
              >
                TALK TO US
              </Button>
            {/* </motion.div> */}
          </motion.div>

          <motion.div 
            className="startup-right"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
          >
            <div className="image-container">
              <img 
                src={developerImage} 
                alt="Developer working" 
                className="developer-image"
              />
              <div className="image-overlay"></div>
            </div>
          </motion.div>
        </div>
      </Container>
    </div>
  );
};

export default StartupSection; 